"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import type { ComponentProps } from "react";

// O editor depende de beforeunload também no Voltar/Avançar do navegador.
// Preserve uma fronteira de documento nessa rota até haver um guard de histórico.
export function AppNavigationLink({ href, ...props }: Omit<ComponentProps<"a">, "href"> & { href: string }) {
  const pathname = usePathname();
  const targetPath = href.split(/[?#]/, 1)[0];
  if (pathname === "/notificacoes" || targetPath === "/notificacoes") {
    return <a href={href} {...props} />;
  }
  return <Link href={href} prefetch={false} {...props} />;
}

export function navigateDocument(href: string) {
  window.location.assign(href);
}

export function replaceDocument(href: string) {
  window.location.replace(href);
}
